import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { createCommercialSupplier } from './api'

const useCreateCommercialSupplier = (onClose: () => void) => {
  const { t } = useTranslation()
  const tPrefix = 'commercial_users.use_create.'

  const errorTypes = ['USER_ALREADY_EXISTING']

  const queryClient = useQueryClient()

  const onSuccess = () => {
    notification.success({
      message: t(`${tPrefix}SUCCESS`),
    })
    queryClient.invalidateQueries(QUERY_KEYS.COMMERCIAL_SUPPLIERS)
    queryClient.invalidateQueries(QUERY_KEYS.COMMERCIAL_SUPPLIER_DETAIL)
    onClose()
  }

  const { mutate, isLoading } = useMutation(createCommercialSupplier, {
    onSuccess,
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data.error as {
        type: string
        status: number
        message: string
      }

      if (errorTypes.includes(errorResponse.type)) {
        notification.error({
          message: t(`${tPrefix}${errorResponse.type}`),
        })
      } else {
        notification.error({
          message: t(`${tPrefix}ERROR`),
        })
      }
    },
  })

  return {
    createCommercialSupplier: mutate,
    isLoadingCreateCommercialSupplier: isLoading,
  }
}

export default useCreateCommercialSupplier
